import ProfileSvg from "@/src/svg/CustomUtils/ProfileSvg";

type BodyColumn = {
  id: string;
  value: string;
};

export const noteConsts = [
  {
    id: "A/23-10001",
    note: [
      {
        title: "Add extra charge",
        cost: "1 180.00 USD",
        date: "17.02.2025",
        description: "The student must cover the additional cost of the diploma",
        img: ProfileSvg,
      },
      {
        title: "Add extra charge",
        cost: "1 180.00 USD",
        date: "17.02.2025",
        description: "The student must cover the additional cost of the diploma",
        img: ProfileSvg,
      },
      {
        title: "Add extra charge",
        cost: "1 180.00 USD",
        date: "17.02.2025",
        description: "The student must cover the additional cost of the diploma",
        img: ProfileSvg,
      },
      {
        title: "Add extra charge",
        cost: "1 180.00 USD",
        date: "17.02.2025",
        description: "The student must cover the additional cost of the diploma",
        img: ProfileSvg,
      },
      {
        title: "Add extra charge",
        cost: "1 180.00 USD",
        date: "17.02.2025",
        description: "The student must cover the additional cost of the diploma",
        img: ProfileSvg,
      },
      {
        title: "Add extra charge",
        cost: "1 180.00 USD",
        date: "17.02.2025",
        description: "The student must cover the additional cost of the diploma",
        img: ProfileSvg,
      },
      {
        title: "Add extra charge",
        cost: "1 180.00 USD",
        date: "17.02.2025",
        description: "The student must cover the additional cost of the diploma",
        img: ProfileSvg,
      },
    ],
  },
  {
    id: "A/23-10002",
    note: [
      {
        title: "Add extra charge",
        cost: "1 180.00 USD",
        date: "25.02.2025",
        description: "The student must cover the additional cost of the diploma",
        img: ProfileSvg,
      },
    ],
  },
  {
    id: "A/23-10003",
    note: [
      {
        title: "Add extra charge",
        cost: "1 180.00 USD",
        date: "30.02.2025",
        description: "The student must cover the additional cost of the diploma",
        img: ProfileSvg,
      },
    ],
  },
];

export type HeaderColumn = {
  id: string;
  title: string;
  subtitle?: string;
};

export const OfficeAccountingTableHeader: HeaderColumn[] = [
  { id: "officeAccountingId", title: "Office Accounting ID" },
  { id: "applicantId", title: "Applicant Id" },
  { id: "fullName", title: "Full Name" },
  { id: "comments", title: "Comments" },
  { id: "campus", title: "Campus" },
  { id: "country", title: "Country" },
  { id: "dateOfBirth", title: "Data of Birth" },
  { id: "studentStatus", title: "Student Status" },
  { id: "passportNo", title: "Passport No" },
  { id: "passportIssued", title: "Passport Issued at" },
  { id: "validPassport", title: "Valid Passport" },
  { id: "phone", title: "Phone" },
  { id: "email", title: "Email" },
  { id: "managersEmail", title: "Manager`s Email" },
  { id: "agentsEmail", title: "Agent`s Email" },
  { id: "levelEducation", title: "Degree" },
  { id: "course", title: "Course" },
  { id: "fieldOfStudy", title: "Field of Study" },
  { id: "formOfEducation", title: "Form of Education" },
  { id: "duration", title: "Duration" },
  { id: "mediumOfInstruction", title: "Medium of Instruction" },
  { id: "admissionSemester", title: "Admission Semester" },
  { id: "intake", title: "Intake" },
  { id: "currentSemester", title: "Current Semester" },
  { id: "generalStatus", title: "Status" },
  { id: "admissionNo", title: "Admission No" }, // верхняя таблица
  { id: "dataAdmission", title: "Data Admission" }, // верхняя таблица
  { id: "tuitionFee", title: "Tuition Fee" }, // верхняя таблица
  { id: "certificationEqualization", title: "Certification & Equalization" },
  { id: "statusAdmissionPayment", title: "Status Admission Payment" }, // верхняя таблица
  { id: "groupNo", title: "Group No:" }, // нижняя таблица
  { id: "residencePermit", title: "Residence Permit" }, // нижняя таблица
  { id: "validUntil", title: "Valid Until" }, // нижняя таблица
  { id: "orderOfThePD", title: "Order of the PD" }, // нижняя таблица
  { id: "opDData", title: "OPD Data" }, // нижняя таблица
  { id: "expulsionOfThePd", title: "Expulsion of the PD" }, // нижняя таблица
  { id: "epDData", title: "EPD Data" }, // нижняя таблица
  { id: "orderOfTheMc", title: "Order of the MC" }, // нижняя таблица
  { id: "omcData", title: "OMC Data" }, // нижняя таблица
  { id: "expulsionOfTheMc", title: "Expulsion of the MC" }, // нижняя таблица
  { id: "emcData", title: "EMC Data" }, // нижняя таблица
  { id: "orderForAcademicLeave", title: "Order for Academic Leave" }, // нижняя таблица
  { id: "durationAl", title: "Duration AL" }, // нижняя таблица
  { id: "statusAl", title: "Status AL" }, // нижняя таблица
  { id: "emailStudentInBase", title: "Email Student in Base" }, // нижняя таблица
  { id: "statusEmail", title: "Status Email" }, // нижняя таблица
  { id: "dateAddEdbo", title: "Date add EDBO" }, // нижняя таблица
  { id: "statusEdbo", title: "Status EDBO" }, // нижняя таблица
  { id: "invitationFee", title: "Invitation Fee" },
  { id: "ifDate", title: "IF Date" },
  { id: "invitationFeePaid", title: "Invitation Fee Paid" },
  { id: "ifDatePaid", title: "IF Date Paid" },
  { id: "statusInvitationFee", title: "Status Invitation Fee" },
  { id: "invoiceNumber", title: "Invoice №" },
  { id: "dataInvoice", title: "Data Invoice" },
  { id: "invoiceAmount", title: "Invoice Amount" },
  { id: "paymentFactUsd", title: "Payment Fact USD" },
  { id: "creditDateUsd", title: "Credit date" },
  { id: "totalAmountUsd", title: "Total Amount USD" },
  { id: "totalPaidUsd", title: "Total Paid USD" },
  { id: "debtBalanceUsd", title: "Debt Balance USD" },
  { id: "balanceStatusUsd", title: "Balance Status USD" },
  { id: "paymentFactEur", title: "Payment Fact EUR" },
  { id: "creditDateEur", title: "Credit date" },
  { id: "totalMissedClassesEur", title: "Total Missed Classes EUR" },
  { id: "balanceMissedClassesEur", title: "Balance Missed Classes EUR" },
  { id: "statusMissedClasses", title: "Status Missed Classes" },
  { id: "totalNostrificationsEur", title: "Total Nostrifications EUR" },
  { id: "balanceNostrificationsEur", title: "Balance Nostrifications EUR" },
  { id: "statusNostrification", title: "Status Nostrification" },
  { id: "preparatoryDepartment", title: "Preparatory Department" },
  { id: "costFirstSemester", title: "Cost of the 1st semester" },
  { id: "costSecondSemester", title: "Cost of the 2st semester" },
  { id: "costThirdSemester", title: "Cost of the 3st semester" },
  { id: "costFouthSemester", title: "Cost of the 4st semester" },
  { id: "costFifthSemester", title: "Cost of the 5st semester" },
  { id: "costSixthSemester", title: "Cost of the 6st semester" },
  { id: "costSeventhSemester", title: "Cost of the 7st semester" },
  { id: "costEighthSemester", title: "Cost of the 8st semester" },
  { id: "costNinthSemester", title: "Cost of the 9st semester" },
  { id: "costTenthSemester", title: "Cost of the 10st semester" },
  { id: "costEleventhSemester", title: "Cost of the 11st semester" },
  { id: "costTwelfthSemester", title: "Cost of the 12st semester" },
  { id: "pgPhdCostFirstSemester", title: "PG/PhD cost 1st semester" },
  { id: "pgPhdCostSecondSemester", title: "PG/PhD cost 2st semester" },
  { id: "pgPhdCostThirdSemester", title: "PG/PhD cost 3st semester" },
  { id: "pgPhdCostFourthSemester", title: "PG/PhD cost 4st semester" },
  { id: "pgPhdCostFifthSemester", title: "PG/PhD cost 5st semester" },
  { id: "pgPhdCostSixthSemester", title: "PG/PhD cost 6st semester" },
  { id: "otherExpenses", title: "Other Expenses" },
  { id: "transfer", title: "Transfer" },
  { id: "insurance", title: "Insurance" },
  { id: "admissionFee", title: "Admission Fee" },
  { id: "temporaryResidencePermission", title: "Temporary Residence Permission" },
  { id: "hostelAccommodation", title: "Hostel Accommodation" },
  { id: "paymentForMissedClasses", title: "Payment for Missed Classes" },
  { id: "nostrification", title: "Nostrification" },
];

export const OfficeAccountingTableBody: BodyColumn[][] = [
  [
    { id: "officeAccountingId", value: "1" },
    { id: "applicantId", value: "101" },
    { id: "fullName", value: "Ada Princes African" },
    { id: "comments", value: "Last Comment" },
    { id: "campus", value: "Ukraine" },
    { id: "country", value: "Ukraine" },
    { id: "dateOfBirth", value: "25.02.1990" },
    { id: "passportNo", value: "FL 907672" },
    { id: "passportIssued", value: "23.09.2027" },
    { id: "validPassport", value: "23.09.2027" },
    { id: "phone", value: "+233543290860" },
    { id: "email", value: "anitaneba97@gmail.com" },
    { id: "managersEmail", value: "admissions@ieu.edu.com" },
    { id: "agentsEmail", value: "edugaine@gmail.com" },
    { id: "course", value: "Bussines Administration" },
    { id: "fieldOfStudy", value: "Masters of Management and B..." },
    { id: "formOfEducation", value: "On Campus" },
    { id: "duration", value: "4 year" },
    { id: "mediumOfInstruction", value: "English" },
    { id: "admissionSemester", value: "1st year, 1st semester" },
    { id: "intake", value: "January 2022" },
    { id: "currentSemester", value: "2st year, 4st semester" },
    { id: "generalStatus", value: "In process" },
    { id: "admissionNo", value: "23059-A/01" }, // верхняя таблица
    { id: "dataAdmission", value: "25.01.2026" }, // верхняя таблица
    { id: "tuitionFee", value: "8 150.00 USD" }, // верхняя таблица
    { id: "certificationEqualization", value: "1 000.00 EUR" },
    { id: "statusAdmissionPayment", value: "Not sorted" }, // верхняя таблица
    ///////
    { id: "groupNo", value: "No: 45 EP " }, // нижняя таблица
    { id: "residencePermit", value: "PH 907675" }, // нижняя таблица
    { id: "validUntil", value: "20.02.2028" }, // нижняя таблица
    { id: "orderOfThePD", value: "No: 01-PZ" }, // нижняя таблица
    { id: "opDData", value: "20.02.2022" }, // нижняя таблица
    { id: "expulsionOfThePd", value: "No: 01-PZ" }, // нижняя таблица
    { id: "epDData", value: "20.02.2022" }, // нижняя таблица
    { id: "orderOfTheMc", value: "No: 01-PZ" }, // нижняя таблица
    { id: "omcData", value: "20.02.2022" }, // нижняя таблица
    { id: "expulsionOfTheMc", value: "No: 01-PZ" }, // нижняя таблица
    { id: "emcData", value: "20.02.2022" }, // нижняя таблица
    { id: "orderForAcademicLeave", value: "AC-20274/54L" }, // нижняя таблица
    { id: "durationAl", value: "22.01.2022-20.09.2022" }, // нижняя таблица
    { id: "statusAl", value: "Not sorted" }, // нижняя таблица
    { id: "emailStudentInBase", value: "adaprincesafrican@ieu.edu.ua " }, // нижняя таблица
    { id: "statusEmail", value: "Not sorted" }, // нижняя таблица
    { id: "dateAddEdbo", value: "22.01.2022" }, // нижняя таблица
    { id: "statusEdbo", value: "Not sorted" }, // нижняя таблица
    ///////
    { id: "invitationFee", value: "1 300 USD" },
    { id: "ifDate", value: "01.02.2026" },
    { id: "invitationFeePaid", value: "1 080 USD" },
    { id: "ifDatePaid", value: "11.02.2026" },
    { id: "statusInvitationFee", value: "Not sorted" },
    { id: "invoiceNumber", value: "23059-I/01" },
    { id: "dataInvoice", value: "11.02.2026" },
    { id: "invoiceAmount", value: "3 080.00 USD" },
    { id: "paymentFactUsd", value: "7 080.00 USD" },
    { id: "creditDateUsd", value: "11.03.2026" },
    { id: "totalAmountUsd", value: "Plan" },
    { id: "totalPaidUsd", value: "Fact" },
    { id: "debtBalanceUsd", value: "=TA-TP" },
    { id: "balanceStatusUsd", value: "Not sorted" },
    { id: "paymentFactEur", value: "2 000.00 EUR" },
    { id: "creditDateEur", value: "11.03.2026" },
    { id: "totalMissedClassesEur", value: "3 080.00 EUR" },
    { id: "balanceMissedClassesEur", value: "3 080.00 EUR" },
    { id: "statusMissedClasses", value: "Not sorted" },
    { id: "totalNostrificationsEur", value: "3 080.00 EUR" },
    { id: "balanceNostrificationsEur", value: "3 080.00 EUR" },
    { id: "statusNostrification", value: "Not sorted" },
    { id: "preparatoryDepartment", value: "1 200.00 USD" },
    { id: "costFirstSemester", value: "2 500.00 USD" },
    { id: "costSecondSemester", value: "2 500.00 USD" },
    { id: "costThirdSemester", value: "2 500.00 USD" },
    { id: "costFouthSemester", value: "2 500.00 USD" },
    { id: "costFifthSemester", value: "2 500.00 USD" },
    { id: "costSixthSemester", value: "2 500.00 USD" },
    { id: "costSeventhSemester", value: "2 500.00 USD" },
    { id: "costEighthSemester", value: "2 500.00 USD" },
    { id: "costNinthSemester", value: "2 500.00 USD" },
    { id: "costTenthSemester", value: "2 500.00 USD" },
    { id: "costEleventhSemester", value: "2 500.00 USD" },
    { id: "costTwelfthSemester", value: "2 500.00 USD" },
    { id: "pgPhdCostFirstSemester", value: "1 200.00 USD" },
    { id: "pgPhdCostSecondSemester", value: "1 200.00 USD" },
    { id: "pgPhdCostThirdSemester", value: "1 200.00 USD" },
    { id: "pgPhdCostFourthSemester", value: "1 200.00 USD" },
    { id: "pgPhdCostFifthSemester", value: "1 200.00 USD" },
    { id: "pgPhdCostSixthSemester", value: "1 200.00 USD" },
    { id: "otherExpenses", value: "800.00 USD" },
    { id: "transfer", value: "1 200.00 USD" },
    { id: "insurance", value: "2 000.00 USD" },
    { id: "admissionFee", value: "2 000.00 USD" },
    { id: "temporaryResidencePermission", value: "1 200.00 USD" },
    { id: "hostelAccommodation", value: "1 200.00 USD" },
    { id: "paymentForMissedClasses", value: "1 200.00 EUR" },
    { id: "nostrification", value: "1 200.00 EUR" },
  ],
  [
    { id: "officeAccountingId", value: "2" },
    { id: "applicantId", value: "102" },
    { id: "fullName", value: "Ada Princes African" },
    { id: "comments", value: "Last Comment" },
    { id: "campus", value: "Ukraine" },
    { id: "country", value: "Ukraine" },
    { id: "dateOfBirth", value: "25.02.1990" },
    { id: "passportNo", value: "FL 907672" },
    { id: "passportIssued", value: "23.09.2027" },
    { id: "validPassport", value: "23.09.2027" },
    { id: "phone", value: "+233543290860" },
    { id: "email", value: "anitaneba97@gmail.com" },
    { id: "managersEmail", value: "admissions@ieu.edu.com" },
    { id: "agentsEmail", value: "edugaine@gmail.com" },
    { id: "course", value: "Bussines Administration" },
    { id: "fieldOfStudy", value: "Masters of Management and B..." },
    { id: "formOfEducation", value: "On Campus" },
    { id: "duration", value: "4 year" },
    { id: "mediumOfInstruction", value: "English" },
    { id: "admissionSemester", value: "1st year, 1st semester" },
    { id: "intake", value: "January 2022" },
    { id: "currentSemester", value: "2st year, 4st semester" },
    { id: "generalStatus", value: "In process" },
    { id: "admissionNo", value: "23059-A/01" }, // верхняя таблица
    { id: "dataAdmission", value: "25.01.2026" }, // верхняя таблица
    { id: "tuitionFee", value: "8 150.00 USD" }, // верхняя таблица
    { id: "certificationEqualization", value: "1 000.00 EUR" },
    { id: "statusAdmissionPayment", value: "Not sorted" }, // верхняя таблица
    ///////
    { id: "groupNo", value: "No: 45 EP " }, // нижняя таблица
    { id: "residencePermit", value: "PH 907675" }, // нижняя таблица
    { id: "validUntil", value: "20.02.2028" }, // нижняя таблица
    { id: "orderOfThePD", value: "No: 01-PZ" }, // нижняя таблица
    { id: "opDData", value: "20.02.2022" }, // нижняя таблица
    { id: "expulsionOfThePd", value: "No: 01-PZ" }, // нижняя таблица
    { id: "epDData", value: "20.02.2022" }, // нижняя таблица
    { id: "orderOfTheMc", value: "No: 01-PZ" }, // нижняя таблица
    { id: "omcData", value: "20.02.2022" }, // нижняя таблица
    { id: "expulsionOfTheMc", value: "No: 01-PZ" }, // нижняя таблица
    { id: "emcData", value: "20.02.2022" }, // нижняя таблица
    { id: "orderForAcademicLeave", value: "AC-20274/54L" }, // нижняя таблица
    { id: "durationAl", value: "22.01.2022-20.09.2022" }, // нижняя таблица
    { id: "statusAl", value: "Not sorted" }, // нижняя таблица
    { id: "emailStudentInBase", value: "adaprincesafrican@ieu.edu.ua " }, // нижняя таблица
    { id: "statusEmail", value: "Not sorted" }, // нижняя таблица
    { id: "dateAddEdbo", value: "22.01.2022" }, // нижняя таблица
    { id: "statusEdbo", value: "Not sorted" }, // нижняя таблица
    ///////
    { id: "invitationFee", value: "1 300 USD" },
    { id: "ifDate", value: "01.02.2026" },
    { id: "invitationFeePaid", value: "1 080 USD" },
    { id: "ifDatePaid", value: "11.02.2026" },
    { id: "statusInvitationFee", value: "Not sorted" },
    { id: "invoiceNumber", value: "23059-I/01" },
    { id: "dataInvoice", value: "11.02.2026" },
    { id: "invoiceAmount", value: "3 080.00 USD" },
    { id: "paymentFactUsd", value: "7 080.00 USD" },
    { id: "creditDateUsd", value: "11.03.2026" },
    { id: "totalAmountUsd", value: "Plan" },
    { id: "totalPaidUsd", value: "Fact" },
    { id: "debtBalanceUsd", value: "=TA-TP" },
    { id: "balanceStatusUsd", value: "Not sorted" },
    { id: "paymentFactEur", value: "2 000.00 EUR" },
    { id: "creditDateEur", value: "11.03.2026" },
    { id: "totalMissedClassesEur", value: "3 080.00 EUR" },
    { id: "balanceMissedClassesEur", value: "3 080.00 EUR" },
    { id: "statusMissedClasses", value: "Not sorted" },
    { id: "totalNostrificationsEur", value: "3 080.00 EUR" },
    { id: "balanceNostrificationsEur", value: "3 080.00 EUR" },
    { id: "statusNostrification", value: "Not sorted" },
    { id: "preparatoryDepartment", value: "1 200.00 USD" },
    { id: "costFirstSemester", value: "2 500.00 USD" },
    { id: "costSecondSemester", value: "2 500.00 USD" },
    { id: "costThirdSemester", value: "2 500.00 USD" },
    { id: "costFouthSemester", value: "2 500.00 USD" },
    { id: "costFifthSemester", value: "2 500.00 USD" },
    { id: "costSixthSemester", value: "2 500.00 USD" },
    { id: "costSeventhSemester", value: "2 500.00 USD" },
    { id: "costEighthSemester", value: "2 500.00 USD" },
    { id: "costNinthSemester", value: "2 500.00 USD" },
    { id: "costTenthSemester", value: "2 500.00 USD" },
    { id: "costEleventhSemester", value: "2 500.00 USD" },
    { id: "costTwelfthSemester", value: "2 500.00 USD" },
    { id: "pgPhdCostFirstSemester", value: "1 200.00 USD" },
    { id: "pgPhdCostSecondSemester", value: "1 200.00 USD" },
    { id: "pgPhdCostThirdSemester", value: "1 200.00 USD" },
    { id: "pgPhdCostFourthSemester", value: "1 200.00 USD" },
    { id: "pgPhdCostFifthSemester", value: "1 200.00 USD" },
    { id: "pgPhdCostSixthSemester", value: "1 200.00 USD" },
    { id: "otherExpenses", value: "800.00 USD" },
    { id: "transfer", value: "1 200.00 USD" },
    { id: "insurance", value: "2 000.00 USD" },
    { id: "admissionFee", value: "2 000.00 USD" },
    { id: "temporaryResidencePermission", value: "1 200.00 USD" },
    { id: "hostelAccommodation", value: "1 200.00 USD" },
    { id: "paymentForMissedClasses", value: "1 200.00 EUR" },
    { id: "nostrification", value: "1 200.00 EUR" },
  ],
  [
    { id: "officeAccountingId", value: "3" },
    { id: "applicantId", value: "103" },
    { id: "fullName", value: "Ada Princes African" },
    { id: "comments", value: "Last Comment" },
    { id: "campus", value: "Ukraine" },
    { id: "country", value: "Ukraine" },
    { id: "dateOfBirth", value: "25.02.1990" },
    { id: "passportNo", value: "FL 907672" },
    { id: "passportIssued", value: "23.09.2027" },
    { id: "validPassport", value: "23.09.2027" },
    { id: "phone", value: "+233543290860" },
    { id: "email", value: "anitaneba97@gmail.com" },
    { id: "managersEmail", value: "admissions@ieu.edu.com" },
    { id: "agentsEmail", value: "edugaine@gmail.com" },
    { id: "course", value: "Bussines Administration" },
    { id: "fieldOfStudy", value: "Masters of Management and B..." },
    { id: "formOfEducation", value: "On Campus" },
    { id: "duration", value: "4 year" },
    { id: "mediumOfInstruction", value: "English" },
    { id: "admissionSemester", value: "1st year, 1st semester" },
    { id: "intake", value: "January 2022" },
    { id: "currentSemester", value: "2st year, 4st semester" },
    { id: "generalStatus", value: "In process" },
    { id: "admissionNo", value: "23059-A/01" }, // верхняя таблица
    { id: "dataAdmission", value: "25.01.2026" }, // верхняя таблица
    { id: "tuitionFee", value: "8 150.00 USD" }, // верхняя таблица
    { id: "certificationEqualization", value: "1 000.00 EUR" },
    { id: "statusAdmissionPayment", value: "Not sorted" }, // верхняя таблица
    ///////
    { id: "groupNo", value: "No: 45 EP " }, // нижняя таблица
    { id: "residencePermit", value: "PH 907675" }, // нижняя таблица
    { id: "validUntil", value: "20.02.2028" }, // нижняя таблица
    { id: "orderOfThePD", value: "No: 01-PZ" }, // нижняя таблица
    { id: "opDData", value: "20.02.2022" }, // нижняя таблица
    { id: "expulsionOfThePd", value: "No: 01-PZ" }, // нижняя таблица
    { id: "epDData", value: "20.02.2022" }, // нижняя таблица
    { id: "orderOfTheMc", value: "No: 01-PZ" }, // нижняя таблица
    { id: "omcData", value: "20.02.2022" }, // нижняя таблица
    { id: "expulsionOfTheMc", value: "No: 01-PZ" }, // нижняя таблица
    { id: "emcData", value: "20.02.2022" }, // нижняя таблица
    { id: "orderForAcademicLeave", value: "AC-20274/54L" }, // нижняя таблица
    { id: "durationAl", value: "22.01.2022-20.09.2022" }, // нижняя таблица
    { id: "statusAl", value: "Not sorted" }, // нижняя таблица
    { id: "emailStudentInBase", value: "adaprincesafrican@ieu.edu.ua " }, // нижняя таблица
    { id: "statusEmail", value: "Not sorted" }, // нижняя таблица
    { id: "dateAddEdbo", value: "22.01.2022" }, // нижняя таблица
    { id: "statusEdbo", value: "Not sorted" }, // нижняя таблица
    ///////
    { id: "invitationFee", value: "1 300 USD" },
    { id: "ifDate", value: "01.02.2026" },
    { id: "invitationFeePaid", value: "1 080 USD" },
    { id: "ifDatePaid", value: "11.02.2026" },
    { id: "statusInvitationFee", value: "Not sorted" },
    { id: "invoiceNumber", value: "23059-I/01" },
    { id: "dataInvoice", value: "11.02.2026" },
    { id: "invoiceAmount", value: "3 080.00 USD" },
    { id: "paymentFactUsd", value: "7 080.00 USD" },
    { id: "creditDateUsd", value: "11.03.2026" },
    { id: "totalAmountUsd", value: "Plan" },
    { id: "totalPaidUsd", value: "Fact" },
    { id: "debtBalanceUsd", value: "=TA-TP" },
    { id: "balanceStatusUsd", value: "Not sorted" },
    { id: "paymentFactEur", value: "2 000.00 EUR" },
    { id: "creditDateEur", value: "11.03.2026" },
    { id: "totalMissedClassesEur", value: "3 080.00 EUR" },
    { id: "balanceMissedClassesEur", value: "3 080.00 EUR" },
    { id: "statusMissedClasses", value: "Not sorted" },
    { id: "totalNostrificationsEur", value: "3 080.00 EUR" },
    { id: "balanceNostrificationsEur", value: "3 080.00 EUR" },
    { id: "statusNostrification", value: "Not sorted" },
    { id: "preparatoryDepartment", value: "1 200.00 USD" },
    { id: "costFirstSemester", value: "2 500.00 USD" },
    { id: "costSecondSemester", value: "2 500.00 USD" },
    { id: "costThirdSemester", value: "2 500.00 USD" },
    { id: "costFouthSemester", value: "2 500.00 USD" },
    { id: "costFifthSemester", value: "2 500.00 USD" },
    { id: "costSixthSemester", value: "2 500.00 USD" },
    { id: "costSeventhSemester", value: "2 500.00 USD" },
    { id: "costEighthSemester", value: "2 500.00 USD" },
    { id: "costNinthSemester", value: "2 500.00 USD" },
    { id: "costTenthSemester", value: "2 500.00 USD" },
    { id: "costEleventhSemester", value: "2 500.00 USD" },
    { id: "costTwelfthSemester", value: "2 500.00 USD" },
    { id: "pgPhdCostFirstSemester", value: "1 200.00 USD" },
    { id: "pgPhdCostSecondSemester", value: "1 200.00 USD" },
    { id: "pgPhdCostThirdSemester", value: "1 200.00 USD" },
    { id: "pgPhdCostFourthSemester", value: "1 200.00 USD" },
    { id: "pgPhdCostFifthSemester", value: "1 200.00 USD" },
    { id: "pgPhdCostSixthSemester", value: "1 200.00 USD" },
    { id: "otherExpenses", value: "800.00 USD" },
    { id: "transfer", value: "1 200.00 USD" },
    { id: "insurance", value: "2 000.00 USD" },
    { id: "admissionFee", value: "2 000.00 USD" },
    { id: "temporaryResidencePermission", value: "1 200.00 USD" },
    { id: "hostelAccommodation", value: "1 200.00 USD" },
    { id: "paymentForMissedClasses", value: "1 200.00 EUR" },
    { id: "nostrification", value: "1 200.00 EUR" },
  ],
];

// Вторая версия таблицы
// export const OfficeAccountingTableHeader: HeaderColumn[] = [
//   { id: "id", title: "ID No" },
//   { id: "fullName", title: "Full Name" },
//   { id: "country", title: "Country" },
//   { id: "dateOfBirth", title: "Data of Birht" },
//   { id: "passportNo", title: "Passport No" },
//   { id: "validPassport", title: "Valid Passport" },
//   { id: "phone", title: "Phone" },
//   { id: "email", title: "Email" },
//   { id: "managersEmail", title: "Manager`s Email" },
//   { id: "agentsEmail", title: "Agent`s Email" },
//   { id: "course", title: "Course" },
//   { id: "fieldOfStudy", title: "Field of Study" },
//   { id: "formOfEducation", title: "Form of Education" },
//   { id: "duration", title: "Duration" },
//   { id: "mediumOfInstruction", title: "Medium of Instruction" },
//   { id: "admissionSemester", title: "Admission Semester" },
//   { id: "intake", title: "Intake" },
//   { id: "generalStatus", title: "General Status" },
//   { id: "groupNo", title: "Group No:" },
//   { id: "residencePermit", title: "Residence Permit" },
//   { id: "validUntil", title: "Valid Until" },
//   { id: "orderOfThePD", title: "Order of the PD" },
//   { id: "opdData", title: "OPD Data" },
//   { id: "expulsionOfThePD", title: "Expulsion of the PD" },
//   { id: "epdData", title: "EPD Data" },
//   { id: "orderOfTheMC", title: "Order of the MC" },
//   { id: "omcData", title: "OMC Data" },
//   { id: "expulsionOfTheMC", title: "Expulsion of the MC" },
//   { id: "emcData", title: "EMC Data" },
//   { id: "academicLeave", title: "Academic Leave" },
//   { id: "emailStudentInBase", title: "Email Student in Base" },
//   { id: "statusEmail", title: "Status Email" },
//   { id: "currency", title: "Currency" },
//   { id: "invitationFeePaid", title: "Invitation Fee Paid" },
//   { id: "ifDate", title: "IF Date" },
//   { id: "statusInvitationFee", title: "Status Invitation Fee" },
//   { id: "invoiceNumber", title: "Invoice №" },
//   { id: "dataInvoice", title: "Data Invoice" },
//   { id: "invoiceAmount", title: "Invoice Amount" },
//   { id: "amountPaid", title: "Amount Paid" },
//   { id: "creditDate", title: "Credit Date" },
//   { id: "paymentStatus", title: "Payment Status" },
//   { id: "totalAmount", title: "Total Amount" },
//   { id: "totalPaid", title: "Total Paid" },
//   { id: "debtBalance", title: "Debt Balance" },
//   { id: "balanceStatus", title: "Balance Status" },
//   { id: "discount", title: "Discount" },
//   { id: "extraCharge", title: "Extra Charge" },
//   { id: "noteAdjustment", title: "Note Adjustment" },
//   { id: "preparatoryDepartment", title: "Preparatory Department" },
//   { id: "costOfTheFirstSemester", title: "Cost of the 1st semester" },
//   { id: "costOfTheSecondSemester", title: "Cost of the 2st semester" },
//   { id: "costOfTheThirdSemester", title: "Cost of the 3st semester" },
//   { id: "costOfTheFouthSemester", title: "Cost of the 4st semester" },
//   { id: "costOfTheFifthSemester", title: "Cost of the 5st semester" },
//   { id: "costOfTheSixthSemester", title: "Cost of the 6st semester" },
//   { id: "costOfTheSeventhSemester", title: "Cost of the 7st semester" },
//   { id: "costOfTheEighthSemester", title: "Cost of the 8st semester" },
//   { id: "costOfTheNinthSemester", title: "Cost of the 9st semester" },
//   { id: "costOfTheTenthSemester", title: "Cost of the 10st semester" },
//   { id: "costOfTheEleventhSemester", title: "Cost of the 11st semester" },
//   { id: "costOfTheTwelfthSemester", title: "Cost of the 12st semester" },
//   { id: "pg_phdCostFirstSemester", title: "PG/PhD cost 1st semester" },
//   { id: "pg_phdCostSecondSemester", title: "PG/PhD cost 2st semester" },
//   { id: "pg_phdCostThirdSemester", title: "PG/PhD cost 3st semester" },
//   { id: "pg_phdCostFourthSemester", title: "PG/PhD cost 4st semester" },
//   { id: "pg_phdCostFifthSemester", title: "PG/PhD cost 5st semester" },
//   { id: "pg_phdCostSixthSemester", title: "PG/PhD cost 6st semester" },
// ];

// export const OfficeAccountingTableBody: BodyColumn[][] = [
//   [
//     { id: "id", value: "A/23-10001" },
//     { id: "fullName", value: "Ada Princes African" },
//     { id: "country", value: "Nigeria" },
//     { id: "dateOfBirth", value: "25.02.1990" },
//     { id: "passportNo", value: "FL 907672" },
//     { id: "validPassport", value: "23.09.2027" },
//     { id: "phone", value: "+233543290860" },
//     { id: "email", value: "anitaneba97@gmail.com" },
//     { id: "managersEmail", value: "admissions@ieu.edu.com" },
//     { id: "agentsEmail", value: "edugaine@gmail.com" },
//     { id: "course", value: "Bussines Administration" },
//     { id: "fieldOfStudy", value: "Masters of Management and B..." },
//     { id: "formOfEducation", value: "On Campus" },
//     { id: "duration", value: "4 year" },
//     { id: "mediumOfInstruction", value: "English" },
//     { id: "admissionSemester", value: "1st year, 1st semester" },
//     { id: "intake", value: "January 2022" },
//     { id: "generalStatus", value: "In process" },
//     { id: "groupNo", value: "No: 45 EP" },
//     { id: "residencePermit", value: "PH 907675" },
//     { id: "validUntil", value: "20.02.2028" },
//     { id: "orderOfThePD", value: "No: 01-PZ" },
//     { id: "opdData", value: "20.02.2022" },
//     { id: "expulsionOfThePD", value: "No: 01-PZ" },
//     { id: "epdData", value: "20.02.2022" },
//     { id: "orderOfTheMC", value: "No: 01-PZ" },
//     { id: "omcData", value: "20.02.2022" },
//     { id: "expulsionOfTheMC", value: "No: 01-PZ" },
//     { id: "emcData", value: "20.02.2022" },
//     { id: "academicLeave", value: "In process" },
//     { id: "emailStudentInBase", value: "adaprincesafrican@ieu.edu.ua " },
//     { id: "statusEmail", value: "In process" },
//     { id: "currency", value: "USD" },
//     { id: "invitationFeePaid", value: "3 080.00 USD" },
//     { id: "ifDate", value: "11.02.2026" },
//     { id: "statusInvitationFee", value: "In process" },
//     { id: "invoiceNumber", value: "23059-I/01" },
//     { id: "dataInvoice", value: "11.02.2026" },
//     { id: "invoiceAmount", value: "3 080.00 USD" },
//     { id: "amountPaid", value: "2 800.00 USD" },
//     { id: "creditDate", value: "11.03.2026" },
//     { id: "paymentStatus", value: "In process" },
//     { id: "totalAmount", value: "=Y+D" },
//     { id: "totalPaid", value: "=Y+D" },
//     { id: "debtBalance", value: "=TA-TP" },
//     { id: "balanceStatus", value: "In process" },
//     { id: "discount", value: "-3 080.00 USD" },
//     { id: "extraCharge", value: "3 080.00 USD" },
//     { id: "noteAdjustment", value: "Last note 17.05.2025" },
//     { id: "preparatoryDepartment", value: "1 200.00 USD" },
//     { id: "costOfTheFirstSemester", value: "2 500.00 USD" },
//     { id: "costOfTheSecondSemester", value: "2 500.00 USD" },
//     { id: "costOfTheThirdSemester", value: "2 500.00 USD" },
//     { id: "costOfTheFouthSemester", value: "2 500.00 USD" },
//     { id: "costOfTheFifthSemester", value: "2 500.00 USD" },
//     { id: "costOfTheSixthSemester", value: "2 500.00 USD" },
//     { id: "costOfTheSeventhSemester", value: "2 500.00 USD" },
//     { id: "costOfTheEighthSemester", value: "2 500.00 USD" },
//     { id: "costOfTheNinthSemester", value: "2 500.00 USD" },
//     { id: "costOfTheTenthSemester", value: "2 500.00 USD" },
//     { id: "costOfTheEleventhSemester", value: "2 500.00 USD" },
//     { id: "costOfTheTwelfthSemester", value: "2 500.00 USD" },
//     { id: "pg_phdCostFirstSemester", value: "1 200.00 USD" },
//     { id: "pg_phdCostSecondSemester", value: "1 200.00 USD" },
//     { id: "pg_phdCostThirdSemester", value: "1 200.00 USD" },
//     { id: "pg_phdCostFourthSemester", value: "1 200.00 USD" },
//     { id: "pg_phdCostFifthSemester", value: "1 200.00 USD" },
//     { id: "pg_phdCostSixthSemester", value: "1 200.00 USD" },
//   ],
//   [
//     { id: "id", value: "A/23-10001" },
//     { id: "fullName", value: "Ada Princes African" },
//     { id: "country", value: "Nigeria" },
//     { id: "dateOfBirth", value: "25.02.1990" },
//     { id: "passportNo", value: "FL 907672" },
//     { id: "validPassport", value: "23.09.2027" },
//     { id: "phone", value: "+233543290860" },
//     { id: "email", value: "anitaneba97@gmail.com" },
//     { id: "managersEmail", value: "admissions@ieu.edu.com" },
//     { id: "agentsEmail", value: "edugaine@gmail.com" },
//     { id: "course", value: "Bussines Administration" },
//     { id: "fieldOfStudy", value: "Masters of Management and B..." },
//     { id: "formOfEducation", value: "On Campus" },
//     { id: "duration", value: "4 year" },
//     { id: "mediumOfInstruction", value: "English" },
//     { id: "admissionSemester", value: "1st year, 1st semester" },
//     { id: "intake", value: "January 2022" },
//     { id: "generalStatus", value: "In process" },
//     { id: "groupNo", value: "No: 45 EP" },
//     { id: "residencePermit", value: "PH 907675" },
//     { id: "validUntil", value: "20.02.2028" },
//     { id: "orderOfThePD", value: "No: 01-PZ" },
//     { id: "opdData", value: "20.02.2022" },
//     { id: "expulsionOfThePD", value: "No: 01-PZ" },
//     { id: "epdData", value: "20.02.2022" },
//     { id: "orderOfTheMC", value: "No: 01-PZ" },
//     { id: "omcData", value: "20.02.2022" },
//     { id: "expulsionOfTheMC", value: "No: 01-PZ" },
//     { id: "emcData", value: "20.02.2022" },
//     { id: "academicLeave", value: "In process" },
//     { id: "emailStudentInBase", value: "adaprincesafrican@ieu.edu.ua " },
//     { id: "statusEmail", value: "In process" },
//     { id: "currency", value: "USD" },
//     { id: "invitationFeePaid", value: "3 080.00 USD" },
//     { id: "ifDate", value: "11.02.2026" },
//     { id: "statusInvitationFee", value: "In process" },
//     { id: "invoiceNumber", value: "23059-I/01" },
//     { id: "dataInvoice", value: "11.02.2026" },
//     { id: "invoiceAmount", value: "3 080.00 USD" },
//     { id: "amountPaid", value: "2 800.00 USD" },
//     { id: "creditDate", value: "11.03.2026" },
//     { id: "paymentStatus", value: "In process" },
//     { id: "totalAmount", value: "=Y+D" },
//     { id: "totalPaid", value: "=Y+D" },
//     { id: "debtBalance", value: "=TA-TP" },
//     { id: "balanceStatus", value: "In process" },
//     { id: "discount", value: "-3 080.00 USD" },
//     { id: "extraCharge", value: "3 080.00 USD" },
//     { id: "noteAdjustment", value: "Last note 17.05.2025" },
//     { id: "preparatoryDepartment", value: "1 200.00 USD" },
//     { id: "costOfTheFirstSemester", value: "2 500.00 USD" },
//     { id: "costOfTheSecondSemester", value: "2 500.00 USD" },
//     { id: "costOfTheThirdSemester", value: "2 500.00 USD" },
//     { id: "costOfTheFouthSemester", value: "2 500.00 USD" },
//     { id: "costOfTheFifthSemester", value: "2 500.00 USD" },
//     { id: "costOfTheSixthSemester", value: "2 500.00 USD" },
//     { id: "costOfTheSeventhSemester", value: "2 500.00 USD" },
//     { id: "costOfTheEighthSemester", value: "2 500.00 USD" },
//     { id: "costOfTheNinthSemester", value: "2 500.00 USD" },
//     { id: "costOfTheTenthSemester", value: "2 500.00 USD" },
//     { id: "costOfTheEleventhSemester", value: "2 500.00 USD" },
//     { id: "costOfTheTwelfthSemester", value: "2 500.00 USD" },
//     { id: "pg_phdCostFirstSemester", value: "1 200.00 USD" },
//     { id: "pg_phdCostSecondSemester", value: "1 200.00 USD" },
//     { id: "pg_phdCostThirdSemester", value: "1 200.00 USD" },
//     { id: "pg_phdCostFourthSemester", value: "1 200.00 USD" },
//     { id: "pg_phdCostFifthSemester", value: "1 200.00 USD" },
//     { id: "pg_phdCostSixthSemester", value: "1 200.00 USD" },
//   ],
//   [
//     { id: "id", value: "A/23-10001" },
//     { id: "fullName", value: "Ada Princes African" },
//     { id: "country", value: "Nigeria" },
//     { id: "dateOfBirth", value: "25.02.1990" },
//     { id: "passportNo", value: "FL 907672" },
//     { id: "validPassport", value: "23.09.2027" },
//     { id: "phone", value: "+233543290860" },
//     { id: "email", value: "anitaneba97@gmail.com" },
//     { id: "managersEmail", value: "admissions@ieu.edu.com" },
//     { id: "agentsEmail", value: "edugaine@gmail.com" },
//     { id: "course", value: "Bussines Administration" },
//     { id: "fieldOfStudy", value: "Masters of Management and B..." },
//     { id: "formOfEducation", value: "On Campus" },
//     { id: "duration", value: "4 year" },
//     { id: "mediumOfInstruction", value: "English" },
//     { id: "admissionSemester", value: "1st year, 1st semester" },
//     { id: "intake", value: "January 2022" },
//     { id: "generalStatus", value: "In process" },
//     { id: "groupNo", value: "No: 45 EP" },
//     { id: "residencePermit", value: "PH 907675" },
//     { id: "validUntil", value: "20.02.2028" },
//     { id: "orderOfThePD", value: "No: 01-PZ" },
//     { id: "opdData", value: "20.02.2022" },
//     { id: "expulsionOfThePD", value: "No: 01-PZ" },
//     { id: "epdData", value: "20.02.2022" },
//     { id: "orderOfTheMC", value: "No: 01-PZ" },
//     { id: "omcData", value: "20.02.2022" },
//     { id: "expulsionOfTheMC", value: "No: 01-PZ" },
//     { id: "emcData", value: "20.02.2022" },
//     { id: "academicLeave", value: "In process" },
//     { id: "emailStudentInBase", value: "adaprincesafrican@ieu.edu.ua " },
//     { id: "statusEmail", value: "In process" },
//     { id: "currency", value: "USD" },
//     { id: "invitationFeePaid", value: "3 080.00 USD" },
//     { id: "ifDate", value: "11.02.2026" },
//     { id: "statusInvitationFee", value: "In process" },
//     { id: "invoiceNumber", value: "23059-I/01" },
//     { id: "dataInvoice", value: "11.02.2026" },
//     { id: "invoiceAmount", value: "3 080.00 USD" },
//     { id: "amountPaid", value: "2 800.00 USD" },
//     { id: "creditDate", value: "11.03.2026" },
//     { id: "paymentStatus", value: "In process" },
//     { id: "totalAmount", value: "=Y+D" },
//     { id: "totalPaid", value: "=Y+D" },
//     { id: "debtBalance", value: "=TA-TP" },
//     { id: "balanceStatus", value: "In process" },
//     { id: "discount", value: "-3 080.00 USD" },
//     { id: "extraCharge", value: "3 080.00 USD" },
//     { id: "noteAdjustment", value: "Last note 17.05.2025" },
//     { id: "preparatoryDepartment", value: "1 200.00 USD" },
//     { id: "costOfTheFirstSemester", value: "2 500.00 USD" },
//     { id: "costOfTheSecondSemester", value: "2 500.00 USD" },
//     { id: "costOfTheThirdSemester", value: "2 500.00 USD" },
//     { id: "costOfTheFouthSemester", value: "2 500.00 USD" },
//     { id: "costOfTheFifthSemester", value: "2 500.00 USD" },
//     { id: "costOfTheSixthSemester", value: "2 500.00 USD" },
//     { id: "costOfTheSeventhSemester", value: "2 500.00 USD" },
//     { id: "costOfTheEighthSemester", value: "2 500.00 USD" },
//     { id: "costOfTheNinthSemester", value: "2 500.00 USD" },
//     { id: "costOfTheTenthSemester", value: "2 500.00 USD" },
//     { id: "costOfTheEleventhSemester", value: "2 500.00 USD" },
//     { id: "costOfTheTwelfthSemester", value: "2 500.00 USD" },
//     { id: "pg_phdCostFirstSemester", value: "1 200.00 USD" },
//     { id: "pg_phdCostSecondSemester", value: "1 200.00 USD" },
//     { id: "pg_phdCostThirdSemester", value: "1 200.00 USD" },
//     { id: "pg_phdCostFourthSemester", value: "1 200.00 USD" },
//     { id: "pg_phdCostFifthSemester", value: "1 200.00 USD" },
//     { id: "pg_phdCostSixthSemester", value: "1 200.00 USD" },
//   ],
// ];

// Первая версия таблицы
// export const OfficeAccountingTableHeader: HeaderColumn[] = [
//   { id: "id", title: "ID No" },
//   { id: "fullName", title: "Full Name" },
//   { id: "country", title: "Country" },
//   { id: "dateOfBirth", title: "Data of Birht" },
//   { id: "phone", title: "Phone" },
//   { id: "email", title: "Email" },
//   { id: "managersEmail", title: "Manager`s Email" },
//   { id: "agentsEmail", title: "Agent`s Email" },
//   { id: "fieldOfStudy", title: "Field of Study" },
//   { id: "mediumOfInstruction", title: "Medium of Instruction" },
//   { id: "admissionSemester", title: "Admission Semester" },
//   { id: "intake", title: "Intake" },
//   { id: "duration", title: "Duration" },
//   { id: "currency", title: "Currency" },
//   { id: "admissionNumber", title: "Admission №" },
//   { id: "dataAdmission", title: "Data admission" },
//   { id: "firstYearFee", title: "First Year Fee" },
//   { id: "paymentStatus_AP", title: "Payment Status", subtitle: "A(P)" },
//   { id: "invitationFee", title: "Invitation Fee" },
//   { id: "actualAmountPaid", title: "Actual amount paid (*)" }, //amountPaid_AP * -> пока не менять
//   { id: "creditDate_AP", title: "Credit date", subtitle: "A(P)" },
//   { id: "paymentStatus_IF", title: "Payment Status", subtitle: "I(F)" },
//   { id: "toAccount_IF", title: "To Account", subtitle: "I(F)" },
//   { id: "invoiceNumber", title: "Invoice №" },
//   { id: "dataInvoice", title: "Data Invoice" },
//   { id: "invoiceAmount", title: "Invoice Amount" },
//   { id: "amountPaid", title: "Amount paid (*)" }, //amountPaid_AIF * -> пока не менять
//   { id: "creditDate_AIF", title: "Credit date", subtitle: "A/I(F)" },
//   { id: "paymentStatus_AIF", title: "Payment Status", subtitle: "A/I(F)" },
//   { id: "toAccount_AIF", title: "To Account", subtitle: "A/I(F)" },
//   { id: "totalAmount", title: "Total Amount" },
//   { id: "totalPaid", title: "Total paid" },
//   { id: "debtBalance", title: "Debt balance" },
//   { id: "paymentStatus_total", title: "Payment Status", subtitle: "(T)" },
//   { id: "discount", title: "Discount" },
//   // { id: "noteAdjustmentFirst", title: "Note Adjustment" },
//   { id: "extraCharge", title: "Extra charge" },
//   { id: "noteAdjustment", title: "Note Adjustment" },
// ];

// export const OfficeAccountingTableBody: BodyColumn[][] = [
//   [
//     { id: "id", value: "A/23-10001" },
//     { id: "fullName", value: "Ada Princes African" },
//     { id: "country", value: "Nigeria" },
//     { id: "dateOfBirth", value: "25.02.1990" },
//     { id: "phone", value: "+233543290860" },
//     { id: "email", value: "anitaneba97@gmail.com" },
//     { id: "managersEmail", value: "admissions@ieu.edu.com" },
//     { id: "agentsEmail", value: "adu@gmail.com" },
//     { id: "fieldOfStudy", value: "Masters of Management and B..." },
//     { id: "mediumOfInstruction", value: "English" },
//     { id: "admissionSemester", value: "1st year, 1st semester" },
//     { id: "intake", value: "January 2022" },
//     { id: "duration", value: "4 year" },
//     { id: "currency", value: "USD" },
//     { id: "admissionNumber", value: "32019-A/01" },
//     { id: "dataAdmission", value: "11.02.2026" },
//     { id: "firstYearFee", value: "3 700.00 USD" },
//     { id: "paymentStatus_AP", value: "Not sorted" },
//     { id: "invitationFee", value: "1300 USD" },
//     { id: "actualAmountPaid", value: "3 080.00 USD" },
//     { id: "creditDate_AP", value: "11.02.2026" },
//     { id: "paymentStatus_IF", value: "In process" },
//     { id: "toAccount_IF", value: "IEU PKO" },
//     { id: "invoiceNumber", value: "23059-I/01" },
//     { id: "dataInvoice", value: "11.02.2026" },
//     { id: "invoiceAmount", value: "3 700.00 USD" },
//     { id: "amountPaid", value: "2 700.00 USD" },
//     { id: "creditDate_AIF", value: "11.02.2026" },
//     { id: "paymentStatus_AIF", value: "Admission" },
//     { id: "toAccount_AIF", value: "IEU PKO" },
//     { id: "totalAmount", value: "=A/I(p)+IF(p)" },
//     { id: "totalPaid", value: "=A/I(f)+IF(f)" },
//     { id: "debtBalance", value: "=TA-TP" },
//     { id: "paymentStatus_total", value: "Reservation" },
//     { id: "discount", value: "-3 080.00 USD" },
//     // { id: "noteAdjustmentFirst", value: "Last note 17.05.2025" },
//     { id: "extraCharge", value: "1 080.00 USD" },
//     { id: "noteAdjustment", value: "Last note 17.05.2025" },
//   ],
//   [
//     { id: "officeAccountingId", value: "2" },
    // { id: "applicantId", value: "102" },
//     { id: "fullName", value: "Ada Princes African" },
//     { id: "country", value: "Nigeria" },
//     { id: "dateOfBirth", value: "25.02.1990" },
//     { id: "phone", value: "+233543290860" },
//     { id: "email", value: "anitaneba97@gmail.com" },
//     { id: "managersEmail", value: "admissions@ieu.edu.com" },
//     { id: "agentsEmail", value: "adu@gmail.com" },
//     { id: "fieldOfStudy", value: "Masters of Management and B..." },
//     { id: "mediumOfInstruction", value: "English" },
//     { id: "admissionSemester", value: "1st year, 1st semester" },
//     { id: "intake", value: "January 2022" },
//     { id: "duration", value: "4 year" },
//     { id: "currency", value: "USD" },
//     { id: "admissionNumber", value: "32019-A/01" },
//     { id: "dataAdmission", value: "11.02.2026" },
//     { id: "firstYearFee", value: "3 700.00 USD" },
//     { id: "paymentStatus_AP", value: "Not sorted" },
//     { id: "invitationFee", value: "1300 USD" },
//     { id: "actualAmountPaid", value: "3 080.00 USD" },
//     { id: "creditDate_AP", value: "11.02.2026" },
//     { id: "paymentStatus_IF", value: "In process" },
//     { id: "toAccount_IF", value: "IEU PKO" },
//     { id: "invoiceNumber", value: "23059-I/01" },
//     { id: "dataInvoice", value: "11.02.2026" },
//     { id: "invoiceAmount", value: "3 700.00 USD" },
//     { id: "amountPaid", value: "2 700.00 USD" },
//     { id: "creditDate_AIF", value: "11.02.2026" },
//     { id: "paymentStatus_AIF", value: "Admission" },
//     { id: "toAccount_AIF", value: "IEU PKO" },
//     { id: "totalAmount", value: "=A/I(p)+IF(p)" },
//     { id: "totalPaid", value: "=A/I(f)+IF(f)" },
//     { id: "debtBalance", value: "=TA-TP" },
//     { id: "paymentStatus_total", value: "Reservation" },
//     { id: "discount", value: "-3 080.00 USD" },
//     // { id: "noteAdjustmentFirst", value: "Last note 17.05.2025" },
//     { id: "extraCharge", value: "1 080.00 USD" },
//     { id: "noteAdjustment", value: "Last note 17.05.2025" },
//   ],
//   [
//     { id: "officeAccountingId", value: "3" },
    // { id: "applicantId", value: "103" },
//     { id: "fullName", value: "Ada Princes African" },
//     { id: "country", value: "Nigeria" },
//     { id: "dateOfBirth", value: "25.02.1990" },
//     { id: "phone", value: "+233543290860" },
//     { id: "email", value: "anitaneba97@gmail.com" },
//     { id: "managersEmail", value: "admissions@ieu.edu.com" },
//     { id: "agentsEmail", value: "adu@gmail.com" },
//     { id: "fieldOfStudy", value: "Masters of Management and B..." },
//     { id: "mediumOfInstruction", value: "English" },
//     { id: "admissionSemester", value: "1st year, 1st semester" },
//     { id: "intake", value: "January 2022" },
//     { id: "duration", value: "4 year" },
//     { id: "currency", value: "USD" },
//     { id: "admissionNumber", value: "32019-A/01" },
//     { id: "dataAdmission", value: "11.02.2026" },
//     { id: "firstYearFee", value: "3 700.00 USD" },
//     { id: "paymentStatus_AP", value: "Not sorted" },
//     { id: "invitationFee", value: "1300 USD" },
//     { id: "actualAmountPaid", value: "3 080.00 USD" },
//     { id: "creditDate_AP", value: "11.02.2026" },
//     { id: "paymentStatus_IF", value: "In process" },
//     { id: "toAccount_IF", value: "IEU PKO" },
//     { id: "invoiceNumber", value: "23059-I/01" },
//     { id: "dataInvoice", value: "11.02.2026" },
//     { id: "invoiceAmount", value: "3 700.00 USD" },
//     { id: "amountPaid", value: "2 700.00 USD" },
//     { id: "creditDate_AIF", value: "11.02.2026" },
//     { id: "paymentStatus_AIF", value: "Admission" },
//     { id: "toAccount_AIF", value: "IEU PKO" },
//     { id: "totalAmount", value: "=A/I(p)+IF(p)" },
//     { id: "totalPaid", value: "=A/I(f)+IF(f)" },
//     { id: "debtBalance", value: "=TA-TP" },
//     { id: "paymentStatus_total", value: "Reservation" },
//     { id: "discount", value: "-3 080.00 USD" },
//     // { id: "noteAdjustmentFirst", value: "Last note 17.05.2025" },
//     { id: "extraCharge", value: "1 080.00 USD" },
//     { id: "noteAdjustment", value: "Last note 17.05.2025" },
//   ],
// ];
